import Component from '../abstracts/Component';

export default class EmailAddressChangeComponent extends Component {

  get SELECTORS() {
    return {
      submitButton: '[data-email-change-submit]',
      privacyCheckbox: '#privacy-email-address-change',
      inputEmail: 'input[type=email]'
    };
  }

  constructor(compEl) {
    super(compEl);
    // elements
    this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
  }

  // istantiate properties
  initProperties() {

  }

 // enable form submit button
  enableSubmitBtn() {
    if ( this.privacyCheckbox.checked === true ) {
       this.submitButton.disabled = false;
    } else {
      this.submitButton.disabled = true;
    }
  }

  // main events function
  bindEvents() {


    // enable submit
    this.privacyCheckbox.addEventListener('click', e => {
      this.enableSubmitBtn();
    });

    // DOM READY
    document.addEventListener("DOMContentLoaded", () => {
      this.enableSubmitBtn();
    });

  }

  // main render function
  render() {
    this.log('Rendering...');
    // init vars
    this.initProperties();
    // go events
    this.bindEvents();
  }
}
